import style from "./Hint.module.scss";
import cn from "classnames";

export function Hint({
    targetElement,
    hintText,
    align = "center"
}: {
    targetElement: JSX.Element,
    hintText: JSX.Element | string,
    align?: "left" | "right" | "center"
}) {
    return (
        <div className={style.hintTarget}>
            {targetElement}
            <div className={cn(style.hintContent, style[align])}>
                {hintText}
            </div>
        </div>
    )
}